import { Component, ElementRef, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup} from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { shareReplay, Subscription } from "rxjs";
import { CountryListService } from "src/app/shared/dummy-data/country-list.service";
import { CandidateEmployerListService } from "src/app/shared/services/candidate-employer-list.service";
import { AuthService } from "src/app/store/auth/auth.service";


@Component({
    selector: "app-candidate-list",
    templateUrl: "./candidate-list.component.html",
    styleUrl: "./candidate-list.component.scss",
})
export class CandidateListComponent {
    userO = this.authService.userO;
    private userSub: Subscription;
    candidateList: any[] = [];
    candidateId: number;
    dataNotFound: string = "Candidate's Not Found";
    currentPage: number = 1;
    totalItemsPerPage = 10;
    totalPages: number = 0;
    totalItems: number = 0;
    firstName: string = "";
    middleName: string = "";
    lastName: string = "";
    email: string = "";
    phoneNumber: string = "";
    employerEmail: FormGroup | any;
    qualification: any[] = [];
    selectedCandidateId: any;
    jobCategory: any[] = [];
    userInfo: any = {};
    category: string = '';
    name: string = '';
    country: string = '';
    candidateRequestId: any;
    loader: boolean = false;
    @ViewChild("cancelButtonRef") cancelButtonRef: ElementRef;
    country_list: any = {};
    city_list: any = {};
    city: any;
   


    constructor(
        private readonly candidateEmployerListService: CandidateEmployerListService,
        private readonly ngxToaster: ToastrService,
        private route: ActivatedRoute,
        private readonly authService: AuthService,
        private readonly countryListService: CountryListService
    ) { }

    
    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            this.category = params['category']
        });
        this.userSub = this.userO.subscribe((data) => {
            if (!data) return;
            if (data?.isData === true) {
                this.userInfo = data?.body;
            } 
        });
        this.getAllEmployerCandidateList();
        this.getCountryCitiesList();
        this.getCountryList()
    }


    //get all Public candidate list
    getAllEmployerCandidateList() {
        this.candidateEmployerListService
            .getAllCandidatesListForEmployer(
                this.currentPage,
                this.totalItemsPerPage,
                this.userInfo?.email,
                this.country,
                this.city
            )
            .subscribe((res: any) => {
                this.candidateList = res?.body;
                if (this.candidateList && this.candidateList.length > 0) {
                     this.totalItems = res?.totalRecords;
                this.totalPages = Math.ceil(
                    this.totalItems / this.totalItemsPerPage
                );
                }else{
                    this.totalItems = 0;
                }
               
            });
    }


    //get Country List
    getCountryList(){
        this.country_list = this.countryListService.getJobCreateCountries()
        }
                    
    //get Country List
    getCountryCitiesList(){
        this.city_list = this.countryListService.getJobCreateCities()
        }

    assign(id: any) {
        this.candidateId = id;
    }

    openModel(id: string) {
        this.selectedCandidateId = id;
    }


    // fetch candidate id 
    candidateModalId(id:any){
     this.candidateRequestId = id
    }


    // submit request
    confirmGenerateRequest() {
        this.loader = true;
        this.candidateEmployerListService.requestCandidate(this.userInfo?.email , this.candidateRequestId).subscribe({
            next: (res: any) => {
                console.log(res?.isData)
                if (res?.isData == true) {
                    this.loader = false;
                    this.ngxToaster.success(res?.result);
                } else {
                    this.loader = false;
                    this.ngxToaster.error(res?.result);
                }
            },
            error: () => {
                this.loader = false;
                this.ngxToaster.error('An error occurred while processing your request.');
            },
        });
    }


    onSelectedCountry(event: any) {
        const selectedCountry = event.value?.country;
        this.country = selectedCountry
        this.getAllEmployerCandidateList()
        if(this.country){
            const allCities = this.countryListService.getJobCreateCities();
            this.city_list = allCities.filter(city => city.country === selectedCountry);
        }else{
            this.country = ""
            this.getCountryCitiesList()
        }
    }



    onSelectedCity(event:any){
       const selectedCity = event.value?.city;
       this.city = selectedCity
       this.getAllEmployerCandidateList()
       const allCities = this.countryListService.getJobCreateCities();

       const match = allCities.find(city => city.city === selectedCity);
       if (match) {
         this.country = match.country;
         this.city_list = allCities.filter(city => city.country === match.country);
       }
    }


    
    onPageChange(page: number) {
        if (page >= 1 && page <= this.totalPages) {
            this.currentPage = page;
            this.getAllEmployerCandidateList();
            window.scrollTo(0, 0);
        }
    }
    


       //ngx-selector-dropDown-Configuration
       CountryConfig = {
        displayKey: "country",
        search: true,
        height: "auto",
        placeholder: "Select Country",
        customComparator: () => {},
        moreText: "more",
        noResultsFound: "No results found!",
        searchPlaceholder: "Search",
        searchOnKey: "country",
        clearOnSelection: false,
        inputDirection: "ltr",
};




    //ngx-selector-dropDown-Configuration
   CitiesConfig = {
        displayKey: "city",
        search: true,
        height: "auto",
        placeholder: "Select City",
        customComparator: () => {},
        moreText: "more",
        noResultsFound: "No results found!",
        searchPlaceholder: "Search",
        searchOnKey: "city",
        clearOnSelection: false,
        inputDirection: "ltr",
};



    ngOnDestroy() {
        this.userSub.unsubscribe();
    }





}
